import { Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { setActivePanel } from "../../redux/slices/panelSlice";
import { dispatch } from "../../redux/store";
import { CustomLoader } from "../../shared/components/others";

import {
  useGetCompetitorAnalysisByIdMutation,
  useGetPostEditorBlogMutation,
} from "../../redux/slices/postEditorBlogSlice";

import {
  ProjectProvider,
  useProject,
} from "./Editor/components/projectContext";

import { t } from "i18next";
import { setCompetitorAnalysis } from "../../redux/slices/competitorSlice";
import Editor from "./Editor";
import "./Tiptap.scss";

const UpdatePostEditor = () => {
  return (
    <ProjectProvider>
      <UpdatePostEditorContent />
    </ProjectProvider>
  );
};

const UpdatePostEditorContent = () => {
  const { id } = useParams();

  const { project, isLoading: projectLoading } = useProject();
  const [blogPost, setBlogPost] = useState(null);
  const hasDispatched = useRef(false);
  const [getPostEditor, { isLoading: getLoading }] =
    useGetPostEditorBlogMutation();
  const [getSingleSeoAnalysis, { isLoading: analysisLoading }] =
    useGetCompetitorAnalysisByIdMutation();

  const handleSingleCompetitorAnalysis = async (id) => {
    try {
      const res = await getSingleSeoAnalysis({ seo_analysis_id: id }).unwrap();
      if (res?.status == 200) {
        dispatch(
          setCompetitorAnalysis({
            data: res?.data,
          })
        );
      }
      loadLinkingTable();
    } catch (error) {}
  };

  const handleGetSingleBlogPost = async (id) => {
    try {
      const res = await getPostEditor({ id }).unwrap();
      const sanitizedData = Object.fromEntries(
        Object.entries(res?.data || {}).map(([key, value]) => [
          key,
          value === null ? "" : value,
        ])
      );

      console.log(res.data);

      setBlogPost(sanitizedData);
      if (sanitizedData.selected_seo_analysis_id) {
        handleSingleCompetitorAnalysis(sanitizedData.selected_seo_analysis_id);
      }
    } catch (error) {}
  };

  useEffect(() => {
    hasDispatched.current = false; // Reset when changing page (id)
    handleGetSingleBlogPost(id);
  }, [id]);

  // Run the dispatch **only once** after fetching the blog post
  useEffect(() => {
    if (
      !hasDispatched.current &&
      blogPost &&
      (!blogPost.seo_request || !blogPost.subject)
    ) {
      dispatch(setActivePanel("outline"));
      hasDispatched.current = true;
    }
  }, [blogPost]);

  return (
    <Box>
      {getLoading || blogPost === null || projectLoading || project === null ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          height={"65vh"}
        >
          <CustomLoader />
        </Box>
      ) : (
        <div>
          <Helmet>
            <title>
              {blogPost.h1_title
                ? blogPost.h1_title
                : t("no-title-post", "(Article sans titre)")}{" "}
              | BotBlogR
            </title>
          </Helmet>
          <ProjectProvider>
            <Editor blogPost={blogPost} />
          </ProjectProvider>
        </div>
      )}
    </Box>
  );
};

export default UpdatePostEditor;
